import { SPACES } from 'common/constants/sizes';
import styled from 'styled-components';

export const StyledScimProvisioning = styled.div`
  margin-top: ${SPACES['x-medium']};
`;
